export default __webpack_public_path__ + "static/media/224.3813b0ba.svg";